<script>
import configure from '../tools/configurator/configure'
import store from '../store'

// const imagePath = require.context('../assets/textures/', true)

export default {
  name: 'materialOption',
  props: {
    option: Object,
    materialName: String
  },
  computed: {
    currentMaterial () {
      return store.getters['materialList/getMaterialByProperty']('name', this.materialName)
    }
  },
  methods: {
    setMaterial (material, option) {
      // using the store form the import helps keep the ui updated even when it's
      // not visible. e.g. when it's triggered from the states menu
      store.commit('materialList/updateVisible', {groupname: material.name, pickedOption: option.title})
      store.commit('materialList/updateTitle', {groupname: material.name, pickedOption: option.title, swatch: option.swatch, icon: option.icon})
      configure.SetMaterialOption(material, option)
    },
    getIconPath (icon) {
      const imagePath = require.context('../assets/textures/', true)
      // eslint-disable-next-line
      return API_URL + imagePath(icon, true)
    }
  }
}
</script>

<template>
<md-menu-item @click="setMaterial(currentMaterial, option)">
  {{option.title}}
  <md-icon v-if="currentMaterial.visible === option.title">check</md-icon>
  <md-button v-if="option.swatch != null" :style="option.swatch" class="md-icon-button md-raised"></md-button>
  <md-button v-if="option.icon != null" class="md-icon-button md-raised">
    <md-avatar>
      <img :src="getIconPath(option.icon)">
    </md-avatar>
  </md-button>
</md-menu-item>
</template>

<style lang="scss" scoped>
  .md-menu {
    width: 300px;
    max-width: 100%;
    display: inline-block;
  }
</style>
